<div class="mb-3" [class.invalid-feedback]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id" class="label">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
    <span *ngIf="key == 'classId'" style="position:absolute; margin-top: -2px;  margin-left: 8px;" class="filter-select-custom-description">
      <nb-icon i18n-nbTooltip="@@SelectTypeToViewRestFiltersDesc" nbTooltip="Для получения дополнительных фильтров необходимо выбрать тип изделия" style="vertical-align: middle;" icon="info-outline" [options]="{width: 18,height: 18}"></nb-icon>
    </span>
  </label>

  @if (!props.simple) {
    <div>
      <ng-select
        size="small"
        i18n-placeholder="@@Select"
        [id]="id"
        appendTo="body"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [items]="selectOptions"
        [multiple]="isMultiple"
        placeholder="Выберите значение"/>
    </div>
  } @else {
      <div style="display: flex">
        <nb-select
          [id]="id"
          [formControl]="formControl"
          [formlyAttributes]="field"
          [multiple]="isMultiple"
          placeholder="Выберите значение"
          fullWidth
          size="tiny"
        >
          <nb-option *ngFor="let item of selectOptions" [value]="item.value" [disabled]="item.disabled">{{item.label}}</nb-option>
      </nb-select>

      <button *ngIf="hasValue" nbButton size="small" status="control" (click)="clear()" type="button">
        <nb-icon icon="close"/>
      </button>
    </div>
  }

  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"/>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
